import React from 'react';
import 'flatpickr/dist/l10n/es';
import "flatpickr/dist/themes/material_red.css";
import Flatpickr from "react-flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import { FormControl, Grid, InputLabel, IconButton, Box } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { Spanish } from "flatpickr/dist/l10n/es.js";

interface MonthPickerProps {
  onChange: (dateString: string) => void;
  flatpickrRef: React.MutableRefObject<Flatpickr | null>;
  dayFixed: number;
  size?: any;
  defaultValue?: string;
  label?: string;
  onClear?: () => void;
  customStyle?: any;
}

const MonthPicker: React.FC<MonthPickerProps> = ({
  flatpickrRef,
  onChange,
  dayFixed,
  size = { xs: 12, sm: 12, md: 12, lg: 12 },
  defaultValue,
  label = "Mes",
  onClear,
  customStyle = {
    font: "inherit",
    fontSize: "14px",
  },
}) => {

  const handleClear = () => {
    flatpickrRef.current?.flatpickr.clear();
    onClear && onClear();
  };

  const convertToFixedDay = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(dayFixed).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <Grid item {...size}>
      <FormControl fullWidth>
        <InputLabel shrink>{label}</InputLabel>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Flatpickr
            ref={flatpickrRef}
            placeholder="Selecciona un mes"
            defaultValue={defaultValue}
            options={{
              locale: Spanish,
              dateFormat: "Y-m",
              altFormat: "F Y",
              plugins: [
                new (monthSelectPlugin as any)({
                  shorthand: true,
                }),
              ],
              onChange: (dates) => {
                if (dates.length > 0) {
                  const fixedDate = convertToFixedDay(dates[0]);
                  onChange(fixedDate);
                }
              },
            }}
            style={{
              width: "100%",
              padding: "0px 9px",
              border: "1px solid #d0d0d0",
              font: "inherit",
              fontSize: "14px",
              height: "53.11px",
              borderRadius: "9px",
              ...customStyle,
            }}
          />

          {onClear && (
            <IconButton
              onClick={handleClear}
              size="small"
              sx={{
                minWidth: "40px",
                height: "40px",
                color: "error.main",
                "&:hover": {
                  backgroundColor: "error.light",
                  color: "error.dark",
                },
              }}
              title="Limpiar mes"
            >
              <ClearIcon />
            </IconButton>
          )}
        </Box>
      </FormControl>
    </Grid>
  );
};

export default MonthPicker;
